export function initRiverReportAction() {
    return {
      type: "INIT_RIVER_REPORT_ACTION",
    };
  }
  export function RiverReportSuccess() {
    return {
      type: "GET_RIVER_REPORT_ACTION",
    };
  }
  export function RiverReportError() {
    return {
      type: "ERROR_RIVER_REPORT_ACTION",
    };
  }